import { render, staticRenderFns } from "./AssignmentInvitation.vue?vue&type=template&id=2d73299f&scoped=true&"
import script from "./AssignmentInvitation.vue?vue&type=script&lang=js&"
export * from "./AssignmentInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentInvitation.vue?vue&type=style&index=0&id=2d73299f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73299f",
  null
  
)

export default component.exports